module.exports = __webpack_public_path__ + "img/ic_share_tw.35941d8d.svg";